import React from 'react';
import { motion } from 'framer-motion';
import { Sparkle } from './Sparkle';
import { CtaButton } from './CtaButton';
import { images } from '../data/content';
export function Hero() {
  return <header className="relative overflow-hidden bg-paper" data-id="element-64" data-mp="9ka5gxomiqwe">
      <div className="mx-auto grid max-w-6xl items-center gap-x-6 px-5 pb-10 pt-6 sm:pt-10 md:pb-16 lg:grid-cols-[1.1fr_1fr] lg:grid-rows-[auto_auto] lg:pb-24 lg:pt-16" data-id="element-65" data-mp="9ipbpaa4vbzl">
        {/* Title block */}
        <div className="lg:col-start-1 lg:row-start-1 lg:self-end" data-id="element-66" data-mp="127eereur1rdz">
          <p className="mb-3 flex items-center gap-2 font-display text-sm font-bold text-ink-soft sm:mb-5" data-id="element-67" data-mp="xbpd95z660f1">
            <Sparkle className="h-4 w-4 text-rust" data-id="element-68" data-mp="s9q6rn84undv" />
            Diario de Prioridad · PDF imprimible
          </p>
          <h1 className="font-display text-[2.4rem] font-black leading-[0.95] tracking-tight text-ink sm:text-6xl lg:text-7xl" data-id="element-69" data-mp="nbydopvr4v83">
            Cómo priorizarte de verdad en 30 días
          </h1>
          <p className="mt-3 font-display text-2xl font-medium italic text-rust-dark sm:mt-4 sm:text-3xl" data-id="element-70" data-mp="3814alm6t1smr">
            y sin complicar tu vida
          </p>
        </div>

        {/* Image: directly under the subtitle on mobile, right column on desktop */}
        <motion.div initial={{
        opacity: 0,
        y: 16,
        scale: 0.98
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative mx-auto -my-4 w-full max-w-[22rem] sm:-my-2 sm:max-w-md lg:col-start-2 lg:row-span-2 lg:row-start-1 lg:my-0 lg:max-w-none" data-id="element-71" data-mp="39b4hx3639y3z">
          <img src={images.stack} alt="Portada kraft del Diario de Prioridad junto a páginas impresas de la lista de afirmaciones" className="w-full mix-blend-multiply" data-id="element-72" data-mp="2qkdd8ex1qvvx" />
          <div className="absolute bottom-[12%] right-0 rotate-[-6deg] rounded-full border-2 border-ink bg-cream px-3 py-2 text-center shadow-[3px_3px_0_0_#141210] sm:right-6 sm:px-4 sm:py-3" data-id="element-73" data-mp="2vglm5aknhsun">
            <span className="block font-display text-xl font-black leading-none sm:text-2xl" data-id="element-74" data-mp="2lmv4aoj14gnx">+160</span>
            <span className="text-[11px] font-medium sm:text-xs" data-id="element-75" data-mp="s3ur9xru3ab5">páginas</span>
          </div>
        </motion.div>

        {/* Body + CTA */}
        <div className="lg:col-start-1 lg:row-start-2 lg:self-start" data-id="element-76" data-mp="ibgod1p0rxne">
          <p className="max-w-xl text-base leading-relaxed text-ink-soft sm:text-lg lg:mt-6" data-id="element-77" data-mp="dd592bfyguxs">
            Todo gracias al primer diario de prioridad en PDF, donde aprenderás a ponerte en primer lugar,
            organizarás tu vida sin estrés y sentirás más claridad cada día.{' '}
            <strong className="font-bold text-ink" data-id="element-78" data-mp="15zzupboie0cu">Desde donde estés, a tu ritmo.</strong>
          </p>
          <div className="mt-6 sm:mt-9" data-id="element-79" data-mp="114kjyslsskkn">
            <CtaButton label="Sí, quiero mi diario ahora" showNote data-id="element-80" data-mp="x02zssbj059c" />
          </div>
        </div>
      </div>
    </header>;
}